import React from 'react'
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom'
import NavBar from './Pages/Home/NavBar';
import Home from './Pages/Home/HomeScreen';
import './App.css';

function App() {
  return (
    <>
      <Router>
          <NavBar/>
          <Routes>
            <Route path='/' element={<Home/>}>
            <Route path='*' element={<div>404 Not Found</div>}>
            </Route>
            </Route>
          </Routes>
      </Router>
    </>
  );
}

export default App;
